import {
  Button,
  Grid,
  Typography,
  CircularProgress,
  Hidden
} from '@material-ui/core'
import i18n from 'i18next'
import { Trans } from 'react-i18next'
import { path } from 'ramda'
import { FC, Fragment, useEffect, useMemo, useState } from 'react'
import { Link as RouterLink } from 'react-router-dom'
import { UpdateStatus } from '../../../../actions/types'
import { ChipList } from '../../../../components/Display/Lists'
import { Message } from '../../../../components/Messages'
import {
  isApartmentCancelledDisabled,
  isApartmentMarketingDisabled
} from '../../../../libs/statuses'
import { MuiClasses } from '../../../../types'
import {
  Apartment,
  ApartmentStatus,
  CheckboxPropertyKeys
} from '../../../../types/apartments'
import { IndexedApplications } from '../../../../types/states'
import { User } from '../../../../types/users'
import { getSortedKeyArray, returnTrueFirst } from '../../../../utils/sorting'
import { getStepPath } from '../../../../utils/steps'
import Dialog from '../../../Dialog'
import {
  getAdditionalPropertiesForOverview,
  getApartmentBuildingInfo
} from '../../Forms/values/apartmentInitialValues'
import { ApartmentExpansionPanel, ApartmentInformationList } from '../Lists'
import { navigate } from '../../../../actions/routes'
import { useDispatch } from 'react-redux';
import '../../../PayForPublish/Rentapp.css';
import apartmentAPI from '../../../../services/apartments'
import { toast } from 'react-toastify'
import Suggest from '../../Stepper/Steps/Suggest'

export interface ApartmentInfoProps {
  t: i18n.TFunction
  classes: MuiClasses
  apartment: Apartment
  user: User | undefined
  isAdmin: boolean
  updateStatus: UpdateStatus
  applications: IndexedApplications
}

const ApartmentInfo: FC<ApartmentInfoProps> = ({
  t,
  classes,
  apartment,
  apartment: {
    applicationIds,
    status,
    information,
    confirmation,
    apartmentId,
    code
  },
  user,
  isAdmin,
  updateStatus,
  applications,
}) => {
  const [selectedApplicationIdForRented, setselectedApplicationIdForRented] = useState("");
  const [isLoading, setIsLoading] = useState({ loading: false, func: '' })
  const wantsPriceEstimate = confirmation.requirePriceEstimate
  const promocode = confirmation.promocode
  const selectedApplication =
    applicationIds &&
      applicationIds?.contractWantedId &&
      applications[apartmentId]
      ? applications[apartmentId].find(
        (application) =>
          application.applicationId === applicationIds.contractWantedId
      )
      : undefined
  const selectedContractWantedName = selectedApplication?.data?.name
    ? selectedApplication?.data?.name
    : undefined
  useEffect(() => {
    setIsLoading({
      loading: false,
      func: ''
    })
  }, [status])

  const availableApplications = useMemo(
    () =>
      Object.values(applications)
        .flat()
        .filter(
          (application) =>
            application &&
            application.apartmentId === apartmentId &&
            application.status !== 'rejected' &&
            application.status !== 'notInterested'
        )
        .sort((applicationA, applicationB) => {
          const nameA = applicationA.data?.name ?? ''
          const nameB = applicationB.data?.name ?? ''

          return nameA.localeCompare(nameB, 'fi', { sensitivity: 'base' })
        }),
    [apartmentId, applications]
  )

  const dispatch = useDispatch();

  const redirectToPaymentPage = () => {
    dispatch(navigate(`/users/${user.userId}/apartments/${apartment.apartmentId}/payment`));
  };

  const handleApplicationChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    setselectedApplicationIdForRented(event.target.value);
  };

  const [updateStatusToRentedClicked, setUpdateStatusToRentedClicked] = useState(false)
  const [updateStatusToRentedDialogHidden, setUpdateStatusToRentedDialogHidden] = useState(false)


  const hideUpdateStatusToRentedDialog = () => {
    setUpdateStatusToRentedDialogHidden(true)
  }

  const unHideUpdateStatusToRentedDialog = () => {
    setUpdateStatusToRentedClicked(false)
    setUpdateStatusToRentedDialogHidden(false)
  }

  const proceedToSettingToRented = () => {
    if (selectedApplicationIdForRented === "") {
      return
    }

    setUpdateStatusToRentedClicked(true)
  }

  const updateStatusToRented = async (inquiry = null) => {
    const status = ApartmentStatus.rented
    setIsLoading({
      loading: true,
      func: 'rent'
    })
    const data = {
      status,
      selectedApplicationIdForRented,
      acceptedService: inquiry
    }
    setUpdateStatusToRentedClicked(false)
    hideUpdateStatusToRentedDialog()
    try {
      await apartmentAPI.UpdateStatusToRented(user.userId, apartmentId, data);
      apartment.status = ApartmentStatus.rented
      //window.location.reload();
      localStorage.setItem('statusUpdatedToRented', 'true');
      const message = t('apartment.overview.setRentedSuccess')
      toast.info(message, { autoClose: 25000 })

    } catch (error) {
      //console.error("Error updating status:", error);
      const message = t('apartment.overview.setRentedFailed')
      toast.info(message, { autoClose: 25000 })
    }
    setIsLoading({
      loading: false,
      func: ''
    })
  }

  // useEffect(() => {
  //   const firstApplicationId = Object.values(applications)
  //     .flat()
  //     .filter(application =>
  //       application.status !== 'rejected' &&
  //       application.status !== 'notInterested' &&
  //       application.apartmentId === apartmentId
  //     )[0]?.applicationId;

  //   if (firstApplicationId) {
  //     setselectedApplicationIdForRented("");
  //   }
  // }, [])

  useEffect(() => {
    const statusUpdatedToRented = localStorage.getItem('statusUpdatedToRented');
    if (statusUpdatedToRented) {
      hideUpdateStatusToRentedDialog();
      localStorage.removeItem('statusUpdatedToRented');
    }
  }, []);

  return (
    <Fragment>
      {information && confirmation && (
        <Grid
          container
          direction='column'
          item
          sm={12}
          md={12}
          lg={5}
          className={classes.textContainer}
          justify='space-between'
        >
          <Grid
            container
            item
            xs={12}
            className={classes.informationRigthSideContainer}
            style={{ paddingTop: isAdmin ? '30px' : '20px' }}
          >
            <Grid
              item
              xs={12}
              sm={6}
              lg={12}
              className={classes.informationContainer}
            >
              {isAdmin && apartment && (
                <Fragment>
                  {(wantsPriceEstimate || promocode) && (
                    <Typography variant='h6' style={{ color: '#3f51b5' }}>
                      {promocode && (confirmation.promocode?.toLowerCase() === 'kumppani'
                        ? 'HUOM! Tämä on yhteistyö, jossa lasku luodaan välittömästi kun ilmoitus on luotu (29% x kuukauden vuokra)'
                        : `Alennuskoodi: ${confirmation.promocode}`)}
                      {promocode && wantsPriceEstimate && ', '}
                      {wantsPriceEstimate && 'Haluaa hinta-arvion!'}
                    </Typography>
                  )}
                  <Typography
                    variant='h6'
                    style={{ color: '#3f51b5', marginBottom: '10px' }}
                  >
                    {`${t('apartment.overview.apartmentCode')}: ${code}`}
                  </Typography>
                </Fragment>
              )}
              <Grid
                item
                xs={12}
                style={{ paddingBottom: '20px', textAlign: 'left' }}
              ><Typography variant='h5'>{t('apartment.propertyInformation')}</Typography>
                <Grid item style={{ marginLeft: 'auto', marginTop: '12px' }}>
                  <Button
                    component={RouterLink}
                    to={getStepPath(apartment, true)}
                    size='small'
                    style={{ marginRight: '10px' }}
                    className={classes.startMarketing}
                  >
                    {t('apartmentOverview.editApartment')}
                  </Button>
                  {status === 'marketing' && isAdmin && (
                    <Dialog
                      dialogId='UpdateStatusToCancelled'
                      disabled={isApartmentCancelledDisabled(status)}
                      color='secondary'
                      title={t('apartments.cancel.label')}
                      buttonLabel={
                        isLoading.loading && isLoading.func === 'cancel' ? (
                          <CircularProgress
                            size={23}
                            style={{ color: '#ff0000' }}
                          />
                        ) : (
                          t('adminApartments.changeStatus.toCancelled')
                        )
                      }
                      buttonClassName={classes.cancelApartment}
                      confirmDialogSubmitAction={() => {
                        setIsLoading({
                          loading: true,
                          func: 'cancel'
                        })
                        updateStatus(ApartmentStatus.cancelled)
                      }}
                      Content={
                        <Message
                          message={t('apartments.cancel.confirmMessage', {
                            address: path(['address'], information) || ''
                          })}
                        />
                      }
                    />
                  )}
                  {status === 'confirmed' && isAdmin && (
                    <>
                      <Dialog
                        dialogId='UpdateStatusToCancelled'
                        disabled={isApartmentCancelledDisabled(status)}
                        color='secondary'
                        title={t('apartments.cancel.label')}
                        buttonLabel={
                          isLoading.loading && isLoading.func === 'cancel' ? (
                            <CircularProgress
                              size={23}
                              style={{ color: '#ff0000' }}
                            />
                          ) : (
                            t('adminApartments.changeStatus.toCancelled')
                          )
                        }
                        buttonClassName={classes.cancelApartment}
                        confirmDialogSubmitAction={() => {
                          setIsLoading({
                            loading: true,
                            func: 'cancel'
                          })
                          updateStatus(ApartmentStatus.cancelled)
                        }}
                        Content={
                          <Message
                            message={t('apartments.cancel.confirmMessage', {
                              address: path(['address'], information) || ''
                            })}
                          />
                        }
                      />
                    </>
                  )}
                  {status === 'rentContractWanted' && (
                    <>
                      <Button
                        size='small'
                        className={classes.cancelApartment}
                        disabled={isApartmentMarketingDisabled(status)}
                        onClick={() => {
                          setIsLoading({
                            loading: true,
                            func: 'market'
                          })
                          //updateStatus(ApartmentStatus.marketing)
                          redirectToPaymentPage()
                        }}
                      >
                        {isLoading.loading && isLoading.func === 'market' ? (
                          <CircularProgress
                            size={23}
                            style={{ color: '#ff0000' }}
                          />
                        ) : (
                          t('adminApartments.changeStatus.rentedToMarketing')
                        )}
                      </Button>
                    </>
                  )}

                  {(status === 'rentContractWanted' || status === 'marketing') && (
                    updateStatusToRentedDialogHidden ? (
                      <Button
                        className={classes.startMarketing}
                        style={{ textTransform: 'uppercase' }}
                        onClick={unHideUpdateStatusToRentedDialog}
                        disabled={isLoading.loading && isLoading.func === 'rent'}
                      >
                        {isLoading.loading && isLoading.func === 'rent' ? (
                          <CircularProgress size={23} style={{ color: 'white' }} />
                        ) : (
                          t('adminApartments.changeStatus.toRented')
                        )}
                      </Button>
                    ) : (
                      <Dialog
                        onClose={() => {
                          setUpdateStatusToRentedClicked(false)
                        }}
                        hideDialog={updateStatusToRentedDialogHidden}
                        dialogId='UpdateStatusToRented'
                        buttonClassName={classes.startMarketing}
                        //title={updateStatusToRentedClicked ? t('apartments.rented.titleWhenClicked') : t('apartments.rented.label')}
                        title={t('apartments.rented.label')}
                        agreeButtonDisabled={selectedApplicationIdForRented === ""}
                        buttonLabel={
                          isLoading.loading && isLoading.func === 'rent' ? (
                            <CircularProgress size={23} style={{ color: 'white' }} />
                          ) : (
                            t('adminApartments.changeStatus.toRented')
                          )
                        }
                        Content={
                          <>
                            {!updateStatusToRentedClicked ? (
                              <>
                                <Grid container spacing={2} style={{ marginTop: 16 }}>
                                  <Grid item sm={12} style={{ marginTop: '-16px' }}>
                                    <Message
                                      message={t('apartments.rented.confirmMessageGeneral', {
                                        applicantName: selectedContractWantedName || t('application.noApplicationFound'),
                                      })}
                                    />
                                  </Grid>

                                  <Grid item sm={12} style={{ marginTop: '-16px' }}>
                                    <select
                                      className="select-dropdown"
                                      onChange={handleApplicationChange}
                                      value={selectedApplicationIdForRented}
                                    >
                                      <option value="" disabled hidden>{t('apartments.rented.chooseTenant')}</option>
                                      {availableApplications.map((application) => (
                                        <option key={application.applicationId} value={application.applicationId}>
                                          {application.data?.name ?? t('application.noApplicationFound')}
                                        </option>
                                      ))}
                                      <option value="someoneElse">{t('apartments.rented.someoneElse')}</option>
                                    </select>
                                  </Grid>

                                  <Grid item sm={12} style={{ marginTop: '-16px' }}>
                                    <Suggest
                                      content={t('apartments.rented.chooseTenantHelper')}
                                      containerMaxWidth="1550px"
                                      contentMaxWidth="1450px"
                                      isModal
                                      padding="25px 0px 15px 0"
                                    />
                                  </Grid>
                                  <Grid item sm={6} xs={12}>
                                    <Button
                                      fullWidth
                                      //className={classes.dialogSaveBtn}
                                      //style={{ textTransform: 'uppercase' }}
                                      style={{
                                        boxShadow: '0px 0px 15px rgba(0, 0, 0, 0.15)',
                                        padding: '8px'
                                      }}
                                      onClick={() => hideUpdateStatusToRentedDialog()}
                                    >
                                      {t('apartments.rented.cancel')}
                                    </Button>
                                  </Grid>
                                  <Grid item sm={6} xs={12}>
                                    <Button
                                      variant="contained"
                                      fullWidth
                                      className={classes.primaryBtn}
                                      onClick={() => proceedToSettingToRented()}
                                    >
                                      {t('apartments.rented.accept')}
                                    </Button>
                                  </Grid>
                                </Grid>
                              </>
                            ) : (
                              <>
                                <Grid container justify="center" style={{ maxWidth: '800px', margin: 'auto' }}>
                                  <Typography variant="h5" align="center" className={classes.modalTitle} style={{ marginTop: '8px' }}>
                                    {t('apartments.rented.rentChargingInquiryTitle')}
                                  </Typography>
                                  <Grid item sm={12} style={{ marginTop: '-16px' }}>
                                    <Suggest
                                      isModal
                                      containerMaxWidth="100%"
                                      contentMaxWidth="100%"
                                      content={
                                        <Trans
                                          t={t}
                                          i18nKey='apartments.rented.rentChargingInquiryInfo'
                                          components={{ strong: <strong /> }}
                                        />
                                      }
                                    />
                                  </Grid>
                                  <Grid container spacing={2} style={{ marginTop: '6px' }}>
                                    <Grid item xs={12}>
                                      <Button
                                        fullWidth
                                        style={{
                                          boxShadow: '0px 0px 15px rgba(0, 0, 0, 0.15)',
                                          padding: '8px'
                                        }}
                                        onClick={() => updateStatusToRented()}
                                      >
                                        {t('apartments.rented.rentChargingInquiryReject')}
                                      </Button>
                                    </Grid>
                                    {/* <Grid item xs={12}>
                                      <Button
                                        variant="contained"
                                        fullWidth
                                        className={classes.primaryBtn}
                                        onClick={() => updateStatusToRented('chargingInquiry')}
                                      >
                                        {t('apartments.rented.rentChargingInquiryAccept')}
                                      </Button>
                                    </Grid> */}
                                    <Grid item xs={12}>
                                      <Button
                                        variant="contained"
                                        fullWidth
                                        className={classes.primaryBtn}
                                        onClick={() => updateStatusToRented('insuranceInquiry')}
                                      >
                                        {t('apartments.rented.rentInsuranceInquiryAccept')}
                                      </Button>
                                    </Grid>
                                  </Grid>
                                </Grid>
                              </>
                            )}
                          </>
                        }
                      />
                    )
                  )}
                  {(status === 'cancelled' || status === 'rented' || status === 'confirmed') && (
                    <Button
                      size='small'
                      className={classes.startMarketing}
                      disabled={isApartmentMarketingDisabled(status)}
                      onClick={() => {
                        setIsLoading({
                          loading: true,
                          func: 'market'
                        })
                        redirectToPaymentPage()
                        //updateStatus(ApartmentStatus.marketing)
                      }}
                    >
                      {isLoading.loading && isLoading.func === 'market' ? (
                        <CircularProgress size={23} style={{ color: 'white' }} />
                      ) : (
                        t('adminApartments.changeStatus.toMarketing')
                      )}
                    </Button>
                  )}
                  <Hidden lgUp>
                    <Grid item xs={12} sm={12} lg={12} className={classes.mt20}>
                      <Grid
                        item
                        xs={12}
                        className={classes.informationContainer}
                      >
                        <Typography className={classes.infoTitle} variant='h5'>
                          {t('apartment.list.information.notes')}
                        </Typography>
                        <Typography variant='body1'>
                          <pre className='MuiTypography-root MuiTypography-body1'>
                            {apartment?.information?.notes || ''}
                          </pre>
                        </Typography>
                      </Grid>
                      <Grid
                        item
                        xs={12}
                        className={classes.informationContainer}
                      >
                        <Typography className={classes.infoTitle} variant='h5'>
                          {t('apartment.list.information.damages')}
                        </Typography>
                        <Typography variant='body1'>
                          <pre className='MuiTypography-root MuiTypography-body1'>
                            {apartment?.information?.damages || ''}
                          </pre>
                        </Typography>
                      </Grid>
                      <Grid
                        item
                        xs={12}
                        className={classes.informationContainer}
                      >
                        <Typography className={classes.infoTitle} variant='h5'>
                          {t('apartment.list.information.renovations')}
                        </Typography>
                        <Typography variant='body1'>
                          <pre className='MuiTypography-root MuiTypography-body1'>
                            {apartment?.information?.renovations || ''}
                          </pre>
                        </Typography>
                      </Grid>
                    </Grid>
                  </Hidden>
                </Grid>
              </Grid>

              <ApartmentInformationList
                apartmentInformation={{
                  ...getApartmentBuildingInfo(confirmation, information),
                  ...getAdditionalPropertiesForOverview(information)
                }}
                t={t}
              />
            </Grid>
            {/* <Grid
            item
            xs={12}
            sm={6}
            lg={12}
            className={classes.informationContainer}
          >
            <AdditionalPropertiesList
              apartmentInformation={getAdditionalPropertiesForOverview(
                information
              )}
              t={t}
            />
          </Grid> */}
            <Grid item xs={12} className={classes.informationContainer}>
              <div style={{ marginBottom: '25px', marginTop: '25px' }}>
                <ChipList
                  data={information}
                  // sorting after getting order to make it look nicer
                  informationOrder={getSortedKeyArray(
                    returnTrueFirst,
                    Object.keys(CheckboxPropertyKeys || {}),
                    information
                  )}
                  // for admin show all, for landlord only show true
                  onlyShowTrue={false}
                  translationPath={'apartment.list.information'}
                />
              </div>
              <ApartmentExpansionPanel
                t={t}
                apartment={apartment}
                user={user}
              />
            </Grid>
          </Grid>
        </Grid>
      )}
    </Fragment>
  )
}

export default ApartmentInfo
